// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__logo___EixMb .styles__wine___yXuEz {
    animation: styles__fillUp___twE2B 1000ms infinite;
  }
  @keyframes styles__fillUp___twE2B {
    from {
      transform: translateY(0px);
      height: 12px;
    }

    to {
      transform: translateY(-130px);
      height: 143px;
    }
  }`, "",{"version":3,"sources":["webpack://./ui/spinner/styles.pcss"],"names":[],"mappings":"AACE;IACE,iDAAiC;EACnC;EAEA;IACE;MACE,0BAA0B;MAC1B,YAAY;IACd;;IAEA;MACE,6BAA6B;MAC7B,aAAa;IACf;EACF","sourcesContent":[".logo {\n  .wine {\n    animation: fillUp 1000ms infinite;\n  }\n\n  @keyframes fillUp {\n    from {\n      transform: translateY(0px);\n      height: 12px;\n    }\n\n    to {\n      transform: translateY(-130px);\n      height: 143px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `styles__logo___EixMb`,
	"wine": `styles__wine___yXuEz`,
	"fillUp": `styles__fillUp___twE2B`
};
export default ___CSS_LOADER_EXPORT___;
